import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { VarianceReason } from '../models/variance-reason.model';

@Injectable()
export class VarianceReasonService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer + "api/VarianceReason/";
    }

    async getVarianceReasonByCode(code: string): Promise<VarianceReason> {
        const params = new HttpParams()
            .set('code', code);

        return await this._http.get<VarianceReason>(`${this.apiServer}GetVarianceReasonByCode`, { params: params}).toPromise<VarianceReason>();
    }

    async getVarianceReasonById(id: number): Promise<VarianceReason> {
        const params = new HttpParams()
            .set('id', id.toString());

        return await this._http.get<VarianceReason>(`${this.apiServer}GetVarianceReasonById`, { params: params}).toPromise<VarianceReason>();
    }

    async getVarianceReasons(): Promise<VarianceReason[]> {
        return await this._http.get<VarianceReason[]>(`${this.apiServer}GetVarianceReasons`).toPromise<VarianceReason[]>();
    }

    async getVarianceReasonsInfiniteScroll(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<VarianceReason[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<VarianceReason[]>(`${this.apiServer}GetVarianceReasonsInfiniteScroll`, { params: params }).toPromise<VarianceReason[]>();
    }

    async removeVarianceReason(id: number): Promise<number> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.delete<number>(`${this.apiServer}RemoveVarianceReason`, { params: params }).toPromise<number>();
    }

    async setVarianceReason(varianceReason: VarianceReason): Promise<VarianceReason> {            
        return await this._http.post<VarianceReason>(`${this.apiServer}SetVarianceReason`, JSON.stringify(varianceReason)).toPromise<VarianceReason>();
    }
    async getCostCentersByVarianceReasonId(id: number): Promise<string[]> {
        const params = new HttpParams()
            .set('Id', id.toString());
            return await this._http.get<string[]>(`${this.apiServer}GetCostCentersByVarianceReasonId`, { params: params }).toPromise<string[]>();
    }
}
